import { UseFormSetError } from 'react-hook-form';

export default function mapFormErrors(
  errors: Record<string, string[]>,
  setError?: UseFormSetError<any>
) {
  if (!setError) return;
  if (setError) {
    Object.entries(errors).forEach(([field, messages]) => {
      setError(field as any, { type: "manual", message: (messages as string[]).join(", ") });
    });
  }
}